
import { IGetClientTypeResponse } from '../../../interfaces/api/IClientsType';
import {api} from '../api';

/**
 * it adds the clients endpoint to the api
 * 
 * @returns ClientsRepository
 */
const ClientsTypeRepository = api.injectEndpoints({
    endpoints: (build) => ({
        getClientsType: build.query<IGetClientTypeResponse, void>({
            query: () => ({url: "/clientTypes", method: "GET"}),          
        }),
    }),
});

export const { useGetClientsTypeQuery } = ClientsTypeRepository;